import BASEURLGESTTOR from '../api/gesttor'

import { atualizarContratoModeloPayload, cadastrarContratoModeloPayload, paramsListarContratoModelo, cadastrarContratoTopicoPayload, cadastrarClausulaPayload } from '../../interfaces/contratosModelos'

export function contratoModelo (payload: cadastrarContratoModeloPayload) {
    return BASEURLGESTTOR.post('/contratos/modelos', payload)
} 

export function atualizarContratoModelo (idContrato: string, payload: atualizarContratoModeloPayload) {
    return BASEURLGESTTOR.patch(`/contratos/modelos?idContratoModelo=${idContrato}`, payload)
}

export function listarContratoModelo (params: paramsListarContratoModelo) {
    return BASEURLGESTTOR.get(`/contratos/modelos?situacao=${params.situacao}&termo=${params.termo}`)
} 

export function cadastrarTopico (idContrato: string, payload: cadastrarContratoTopicoPayload) {
    return BASEURLGESTTOR.post(`/contratos/topicos/${idContrato}`, payload)
} 

export function listarTopicos (idContratoTopico: string) {
    return BASEURLGESTTOR.get(`/contratos/topicos/${idContratoTopico}`)
} 

export function cadastrarClausula (payload: cadastrarClausulaPayload) {
    return BASEURLGESTTOR.post('/contratos/clausulas', payload)
} 

export function listarClausulas (idContrado: string) {
    return BASEURLGESTTOR.get(`/contratos/clausulas/${idContrado}`)
} 

